import React from 'react'
import './style.css'



const Menu = () => {
 
    return (
        < >
            <div className="sty">

                    <div className="letter-menu">
                        <p >Maria Estela</p>
                        <p className="letter-text">Desenvolvedora web </p>
                    </div>

            </div>
        </>
        )}
export default Menu 